var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scroll-wrap" }, [
    _c("div", { staticClass: "scroll-content" }, [
      _c(
        "div",
        {
          staticClass: "header",
          style: { backgroundImage: `url(${_vm.headerImage})` },
        },
        [
          _c("div", {
            staticClass: "ruleBtn",
            on: {
              click: function ($event) {
                return _vm.openModal("modalRuleShow")
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "infoBox",
          style: { backgroundImage: `url(${_vm.infoImage})` },
        },
        [
          _c("GetInfo", {
            attrs: {
              getCouponFlag: _vm.getCouponFlag,
              share_channel: _vm.share_channel,
              startTime: _vm.startTime,
            },
            on: { jumpUrl: _vm.jumpUrl, Refresh: _vm.Refresh },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rule" }, [
        _c("img", { attrs: { alt: "", src: _vm.ruleImage } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }